import { GlobalDiscount } from '../../quotes/utils/compute-totals-local.util';
import { DiscountType } from '../../shared/types/discount.type';

type OrderOfferLike = { reduction: DiscountType; amount: number };
type CompanyDiscountLike = { value: number; reduction: DiscountType };
type OrderDiscountLike = { value: number; reduction: DiscountType };

export function resolveOrderTotalsDiscountInputs(
  offer?: OrderOfferLike,
  companyDiscount?: CompanyDiscountLike,
  discount?: OrderDiscountLike
): { companyDiscountPercent?: number; globalDiscount?: GlobalDiscount } {
  const explicitGlobalDiscount: GlobalDiscount | undefined = discount
    ? { value: discount.value, reduction: discount.reduction }
    : undefined;

  if (offer) {
    return {
      companyDiscountPercent: offer.reduction === 'percent' ? offer.amount : undefined,
      globalDiscount:
        explicitGlobalDiscount ?? (offer.reduction === 'flat' ? { value: offer.amount, reduction: 'flat' } : undefined),
    };
  }

  return {
    companyDiscountPercent: companyDiscount?.reduction === 'percent' ? companyDiscount.value : undefined,
    globalDiscount:
      explicitGlobalDiscount ??
      (companyDiscount?.reduction === 'flat' ? { value: companyDiscount.value, reduction: 'flat' } : undefined),
  };
}
